import { MenuItem } from "./menu.types";

export const menuItems1: MenuItem[] = [
  { id: 1, label: "Dashboard", icon: "las la-home", to: "/", permissionId: 1 },
  { id: 2, label: "Roles", icon: "las la-check-circle", to: "/role", permissionId: 2 },
  { id: 4, label: "Matching", icon: "las la-project-diagram", to: "/Fleet", permissionId: 8 },
  { id: 9, label: "OEM profile", icon: "las la-user-tie", to: "/oem-profile", permissionId: 9},
  { id: 10, label: "Supplier profile", icon: "las   la-user", to: "/ProfileSupplier", permissionId: 10 },
];
